// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"166d2908","693":"e2d562e7"}[chunkId] + ".chunk.js";
};